/**
 * @fileoverview The Redux store configuration for the application.
 *
 * @example
 * // Usage in index.tsx or App.tsx
 * import { store } from './store'
 *
 * function App() {
 *   return <Provider store={store}><App /></Provider>
 * }
 */

import { configureStore } from '@reduxjs/toolkit'

import { assignmentsApi } from './services/assignments'
import { batteriesApi } from './services/batteries'
import { eventsApi } from './services/events'
import { invitesApi } from './services/invites'
import { participantsApi } from './services/participants'
import { sitesApi } from './services/sites'
import { staffApi } from './services/staff'
import { studiesApi } from './services/studies'
import { usersApi } from './services/users'

export const store = configureStore({
    reducer: {
        [sitesApi.reducerPath]: sitesApi.reducer,
        [batteriesApi.reducerPath]: batteriesApi.reducer,
        [participantsApi.reducerPath]: participantsApi.reducer,
        [studiesApi.reducerPath]: studiesApi.reducer,
        [assignmentsApi.reducerPath]: assignmentsApi.reducer,
        [staffApi.reducerPath]: staffApi.reducer,
        [usersApi.reducerPath]: usersApi.reducer,
        [eventsApi.reducerPath]: eventsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            sitesApi.middleware,
            batteriesApi.middleware,
            participantsApi.middleware,
            studiesApi.middleware,
            invitesApi.middleware,
            staffApi.middleware,
            assignmentsApi.middleware,
            usersApi.middleware,
            eventsApi.middleware
        ),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
